import { useState, useEffect } from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { getPrivacyPolicyContent } from '../config/firebase';

export function PrivacyPolicy() {
  const navigate = useNavigate();
  const [content, setContent] = useState('');

  useEffect(() => {
    const fetchContent = async () => {
      const text = await getPrivacyPolicyContent();
      if (text) setContent(text);
    };
    fetchContent();
  }, []);

  return (
    <div className="min-h-screen">
      <div className="backdrop-blur-lg text-white p-4 flex items-center justify-between sticky top-0 z-10 border-b border-white/10">
        <button
          onClick={() => navigate(-1)}
          className="text-gray-400 hover:text-white transition-colors"
        >
          <ArrowLeft className="w-6 h-6" />
        </button>
        <h1 className="text-lg font-bold">Politique de confidentialité</h1>
        <div className="w-6" />
      </div>

      <div className="container mx-auto px-4 py-8 max-w-2xl">
        <div className="prose prose-invert">
          {content.split('\n').map((line, index) => (
            <p key={index} className="text-gray-400" dangerouslySetInnerHTML={{ __html: line }} />
          ))}
        </div>
      </div>
    </div>
  );
}